import { ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import Seo from "../components/Seo";

// Catch-all 404. The key SEO job here is `noindex` so search engines don't index
// error URLs. A 404 deliberately carries no Service/FAQ/Breadcrumb schema — rich
// structured data on an error page would misrepresent it to crawlers and AI.
const NotFound: React.FC = () => {
  return (
    <>
      <Seo
        title="Page Not Found | Contextral"
        description="The page you are looking for does not exist or may have moved."
        noindex
      />
      <section id="hero" className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-5xl mx-auto">
            <p className="text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-accentDeep mb-4">
              Error 404
            </p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight text-text-primary animate-fade-in-up">
              Page Not Found
            </h1>

            <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8 max-w-4xl mx-auto leading-relaxed text-text-secondary animate-fade-in-up delay-200 px-2">
              The page you are looking for does not exist or may have moved.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-8 sm:mb-12 animate-fade-in-up delay-400">
              <NavLink
                to="/"
                className="group bg-primary text-text-inverse px-8 py-4 rounded-full text-lg font-semibold hover:bg-primaryHover transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-primary/30 flex items-center"
              >
                Head Home
                <ArrowRight aria-hidden="true" className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
